import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useUserSchema = () => {
  const { t } = useTranslation();

  const userSchema = z.object({
    firstName: z
      .string()
      .nonempty({
        message: t("errors.requiredField", { fieldName: t("common.firstName") }),
      })
      .min(2, {
        message: t("errors.fieldMin", { fieldName: t("common.firstName") }),
      })
      .max(32, {
        message: t("errors.fieldMax", { fieldName: t("common.firstName") }),
      }),

    lastName: z
      .string()
      .nonempty({
        message: t("errors.requiredField", { fieldName: t("common.lastName") }),
      })
      .min(2, {
        message: t("errors.fieldMin", { fieldName: t("common.lastName") }),
      })
      .max(32, {
        message: t("errors.fieldMax", { fieldName: t("common.lastName") }),
      }),

    role: z
      .string()
      .nonempty({
        message: t("errors.requiredField", { fieldName: t("common.role") }),
      }),

    email: z
      .string()
      .nonempty({
        message: t("errors.requiredField", { fieldName: t("common.email") }),
      })
      .email({
        message: t("errors.emailInvalid", { fieldName: t("common.email") }),
      })
      .max(256, {
        message: t("errors.emailMax", { fieldName: t("common.email") }),
      }),

    infix: z
      .string()
      .nullable()
      .refine(
        (value) => !value || value.length >= 2,
        { message: t("errors.fieldMin", { fieldName: t("common.infix") }) }
      )
      .refine(
        (value) => !value || value.length <= 32,
        { message: t("errors.fieldMax", { fieldName: t("common.infix") }) }
      ),
  });

  return { userSchema };
};
